module.exports = import("https://cdn.skypack.dev/debounce");;